export const environment = {
  production: false,
  baseUrl: "https://localhost:52001/",
  tallyBaseUrl: "http://localhost:9000",
  // tallyBaseUrl: "/api"
};